import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const engineerToolGuard = createFeatureGuard(Feature.EngineersDamageClass);
